import React, { useRef } from 'react';
import ArrowDown from '../icons/down_button.png';

const ScrollButton = () => {
  const buttonRef = useRef(null);

  const scrollToNext = () => {
    if (buttonRef.current) {
      const buttonBottom = buttonRef.current.getBoundingClientRect().bottom;
      const scrollAmount = buttonBottom + window.scrollY - 80;
      
      window.scrollTo({
        top: scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="w-full flex justify-center my-2" ref={buttonRef}>
      <button
        onClick={scrollToNext}
        className="p-0 rounded-full transition-colors duration-200 cursor-pointer"
        aria-label="Scroll to next section"
      >
        <img src={ArrowDown} alt="Scroll down" className="w-16 h-16 animate-bounce" />
      </button>
    </div>
  );
};

export default ScrollButton;